const DEFAULT_MAX_BYTES = 1024 * 1024;

export function getDataUrlByteSize(dataUrl) {
  const base64 = String(dataUrl || "").split(",")[1] || "";
  if (!base64) {
    return 0;
  }
  const padding = (base64.match(/=+$/) || [""])[0].length;
  return Math.floor((base64.length * 3) / 4) - padding;
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la imagen"));
    };
    image.src = url;
  });
}

function drawToJpegDataUrl(image, maxSide, quality) {
  const scale = Math.min(1, maxSide / Math.max(image.width, image.height));
  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, width, height);

  return canvas.toDataURL("image/jpeg", quality);
}

/**
 * Comprime una imagen hasta que el resultado en base64 no supere maxBytes.
 */
export async function compressImageFile(file, maxBytes = DEFAULT_MAX_BYTES) {
  if (!file?.type?.startsWith("image/")) {
    throw new Error("El archivo no es una imagen válida");
  }

  const image = await loadImageFromFile(file);
  let maxSide = 1920;
  let bestDataUrl = null;

  while (maxSide >= 480) {
    let quality = 0.92;

    while (quality >= 0.35) {
      const dataUrl = drawToJpegDataUrl(image, maxSide, quality);
      bestDataUrl = dataUrl;

      if (getDataUrlByteSize(dataUrl) <= maxBytes) {
        return dataUrl;
      }

      quality -= 0.07;
    }

    maxSide = Math.floor(maxSide * 0.75);
  }

  if (bestDataUrl && getDataUrlByteSize(bestDataUrl) <= maxBytes) {
    return bestDataUrl;
  }

  throw new Error("No se pudo comprimir la imagen por debajo de 1 MB");
}

export function dataUrlToFile(dataUrl, filename = "photo.jpg") {
  const parts = String(dataUrl || "").split(",");
  const mimeMatch = parts[0]?.match(/:(.*?);/);
  const mime = mimeMatch?.[1] || "image/jpeg";
  const binary = atob(parts[1] || "");
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], filename, { type: mime });
}
